import { useState, useEffect } from 'react';
import { useSubscription } from '../contexts/Appsync/Appsync';
import { SUBSCRIBE_STREAM_VIEWER_COUNT } from '../graphql/operations';

const useViewerCount = () => {
  const [viewerCount, setViewerCount] = useState(0);
  const [timestamp, setTimestamp] = useState(null);
  const [error, setError] = useState(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const { data, error: subscriptionError } = useSubscription(
    SUBSCRIBE_STREAM_VIEWER_COUNT
  );

  useEffect(() => {
    if (subscriptionError) {
      setError(subscriptionError);
    }
  }, [subscriptionError]);

  useEffect(() => {
    if (!isOnline) {
      setViewerCount(0);
      return;
    }

    if (data?.onConcurrentViewers) {
      const { count, timestamp } = data.onConcurrentViewers;
      setViewerCount(count);
      setTimestamp(timestamp);
    }
  }, [data, isOnline]);

  // Format viewer count (e.g., 1000 -> 1k)
  const formatViewerCount = (count) => {
    if (count >= 1000000) {
      return `${(count / 1000000).toFixed(1)}M`;
    }
    if (count >= 1000) {
      return `${(count / 1000).toFixed(1)}k`;
    }
    return count.toString();
  };

  return {
    viewerCount: isOnline ? viewerCount : 0,
    formattedViewerCount: formatViewerCount(isOnline ? viewerCount : 0),
    timestamp,
    error,
    isOnline
  };
};

export default useViewerCount;